export default __webpack_public_path__ + "static/media/upl.8fdbb9e0.svg";